// src/components/admin/StatCard.tsx
import React from 'react';

interface StatCardProps {
    title: string;
    value: string | number;
    icon: React.ReactNode;
    trend?: string;
    trendLabel?: string;
}

export function StatCard({ title, value, icon, trend, trendLabel }: StatCardProps) {
    const isPositiveTrend = trend?.startsWith('+');
    
    return (
        <div className="group relative bg-white p-6 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-200 hover:border-brand-blue/30 overflow-hidden">
            {/* Background gradient decorativo */}
            <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-brand-blue/5 to-transparent rounded-full transform translate-x-16 -translate-y-16 group-hover:scale-150 transition-transform duration-500"></div>
            
            <div className="relative flex items-start justify-between gap-4">
                <div className="flex-1 min-w-0 pr-2">
                    <p className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide whitespace-nowrap">{title}</p>
                    <p className="text-xl sm:text-2xl font-extrabold text-gray-900 mb-3 whitespace-nowrap">{value}</p>
                    
                    {trend && trendLabel && (
                        <div className="flex items-center gap-2">
                            <span className={`inline-flex items-center gap-1 text-xs font-semibold px-2 py-1 rounded-full ${
                                isPositiveTrend 
                                    ? 'bg-green-100 text-green-700' 
                                    : 'bg-red-100 text-red-700'
                            }`}>
                                {isPositiveTrend ? (
                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                                    </svg>
                                ) : (
                                    <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                                    </svg>
                                )}
                                {trend}
                            </span>
                            <span className="text-xs text-gray-500 whitespace-nowrap">{trendLabel}</span>
                        </div>
                    )}
                </div>
                
                <div className="flex-shrink-0 bg-gradient-to-br from-brand-blue to-blue-600 p-4 rounded-2xl shadow-lg group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                    <div className="text-white">
                        {icon}
                    </div>
                </div>
            </div>
            
            {/* Barra de destaque na parte inferior */}
            <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-brand-blue to-blue-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
        </div>
    );
}